import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { ContentProvider, useContent } from "./context/ContentContext";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import OurStory from "./pages/OurStory";
import WeddingDetails from "./pages/WeddingDetails";
import Travel from "./pages/Travel";
import Registry from "./pages/Registry";
import RSVP from "./pages/RSVP";
import FAQ from "./pages/FAQ";

function SEO() {
  const { content } = useContent();
  useEffect(() => {
    if (!content?.seo) return;
    document.title = content.seo.title || "Vernetta & Quin";
    let m = document.querySelector('meta[name="description"]');
    if (!m) { m = document.createElement("meta"); m.name = "description"; document.head.appendChild(m); }
    m.content = content.seo.description || "";
    let r = document.querySelector('meta[name="robots"]');
    if (!r) { r = document.createElement("meta"); r.name = "robots"; document.head.appendChild(r); }
    r.content = content.seo.noindex ? "noindex, nofollow" : "index, follow";
  }, [content]);
  return null;
}

function App() {
  return (
    <ContentProvider>
      <SEO />
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/our-story" element={<OurStory />} />
            <Route path="/wedding-details" element={<WeddingDetails />} />
            <Route path="/travel" element={<Travel />} />
            <Route path="/registry" element={<Registry />} />
            <Route path="/rsvp" element={<RSVP />} />
            <Route path="/faq" element={<FAQ />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" />
    </ContentProvider>
  );
}

export default App;
